import script from "./PoliciesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoliciesSection.vue?vue&type=script&setup=true&lang=ts"

import "./PoliciesSection.vue?vue&type=style&index=0&id=e5dc31dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5dc31dc"]])

export default __exports__